module.exports = {"id":"190014","name":"Yannis Salibur","rating":"77","photo":"./data/images/photos/2/190014.png","club":{"name":"EA Guingamp","logo":"./data/images/clubs/EAGuingamp.png"},"positions":["MD","AD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YannisSalibur0.json
// module id = 4390
// module chunks = 0